// extracted by mini-css-extract-plugin
module.exports = {"progress_content":"styles_progress_content__ckcQ3","progress_title":"styles_progress_title__3Qk61"};